import React from 'react';

type SecondaryButtonProps = React.ButtonHTMLAttributes<HTMLButtonElement>;

const SecondaryButton: React.FC<SecondaryButtonProps> = ({ children, ...props }) => (
    <button {...props} style={{ ...baseStyle, ...props.style }}>
        {children}
    </button>
);

const baseStyle: React.CSSProperties = {
    padding: 10,
    background: '#f0faf5',
    color: '#2d7a50',
    border: '1px solid #c5e8d4',
    borderRadius: 8,
    fontFamily: "'Caveat',cursive",
    fontSize: 16,
    fontWeight: 700,
    cursor: 'pointer',
    width: '100%',
};

export default SecondaryButton;
